import React from 'react';

import './Arrows.scss';

const Arrows = (props) => {
  const { handleMoveSlider } = props;

  return (
    <div className="arrows">
      <button onClick={handleMoveSlider} data-direction="1" className="arrows__item arrows__item_left disabled"></button>
      <button onClick={handleMoveSlider} data-direction="-1" className="arrows__item arrows__item_right"></button>
    </div>
  )
}

export default Arrows;


// WEBPACK FOOTER //
// ./src/components/Arrows/Arrows.js